<template>
  <div>
    <div v-show="!video">
      <div class="Videos">
        <div v-for="video in data.videos" class="VideoCell" :key="video.video_id">
          <div
            class="VideoCell__cover"
            :style="{ backgroundImage: `url(${video.cover.replace('{$width}', '324')})`}"
            @click="handleVideo(video)"
          >
            <playBtn />
          </div>
          <div class="VideoCell__title">
            {{ video.title }}
          </div>
        </div>
      </div>
      <div class="Videos">
        <div v-for="link in data.external_links" class="VideoCell" :key="link.title">
          <a
            class="VideoCell__cover"
            :style="{ backgroundImage: `url(${link.cover.replace('{$width}', '324')})`}"
            :href="link.url"
          >
          </a>
          <div class="VideoCell__title">
            {{ link.title }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="video">
      <Player360 v-if="showVideo360" :url="video.stream_hls" :token="token" @exit="exit()" />
      <Player v-if="showVideo" :url="video.stream_hls" @exit="exit()" />
    </template>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { get } from 'lodash';
import Player from '@/components/Player.vue';
import Player360 from '@/components/Player360.vue';
import PlayBtn from './glyphs/PlayBtn.vue';

export default {
  name: 'RDS',
  components: { Player, Player360, PlayBtn },
  data() {
    return {
      get,
      showVideo: false,
      showVideo360: false,
      token: false,
      events: false,
      exp: false,
      status: false,
      data: false,
      video: false,
    };
  },
  beforeMount() {
    this.$store.commit('appReady', true);
    const {
      status,
      token,
      exp,
      events,
    } = get(this.$route, 'query');
    this.token = token;
    this.status = status;
    this.exp = exp;
    this.events = events.split('|');
  },
  mounted() {
    let params = '?';
    this.events.forEach((e) => {
      params += `&event=${e}`;
    });
    params = params.replace('?&', '?');
    this.papi.get(`/rds${params}`, {
      headers: {
        'x-tok-token': this.token,
        'Accept-Language': this.locale,
      },
    }).then((response) => {
      this.data = get(response, 'data');
    });
  },
  computed: {
    ...mapState([
      'api',
      'papi',
      'locale',
      'rdsPlayer',
      'rdsPlayer360',
      'rdsPlayerShow',
      'rdsPlayer360Show',
    ]),
    ...mapGetters(['getPI']),
  },
  methods: {
    ...mapMutations([
      'setRdsPlayer',
      'setRdsPlayer360',
      'setRdsPlayerShow',
      'setRdsPlayer360Show',
    ]),
    ...mapActions(['handleVideo']),
    exit() {
      this.video = false;
      this.showVideo = false;
      this.showVideo360 = false;
    },
    handleVideo(payload) {
      this.papi.get(`/video/${payload.video_id}`, {
        headers: {
          'x-tok-token': this.token,
          'Accept-Language': this.locale,
        },
      }).then((response) => {
        this.video = response.data;
        if (this.video.video_360) {
          this.showVideo360 = true;
          this.showVideo = false;
        } else {
          this.showVideo360 = false;
          this.showVideo = true;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.video-js-vr {
  height: 100vh;
}

.Videos {
  display: flex;
  padding: 20px;
}

.VideoCell {
  margin: 20px;
  flex: 0 1 33%;

  &__cover {
    padding-top: 56.25%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-size: cover;
  }

  &__title {
    margin-top: 15px;
    color: white;
  }
}

.playBtn {
  position: absolute;
  top: 0;
}
</style>
